import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getPriceGroupDetails } from "../../helpers/http_price_groups_requests";

export default function PriceGroupDetails() {

    const navigate = useNavigate();

    const { id } = useParams();

    const [formData, setFormData] = useState({});

    const formFieldList = [
        {
            title: "Informações do Grupo",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: 'high_gold_index',
                    label: 'Ouro 18K',
                    type: "number",
                    required: true,
                },
                {
                    name: 'high_gold_crafted_index',
                    label: 'Ouro 18K Trabalhado',
                    type: "number",
                    required: true,
                },
                {
                    name: 'low_gold_index',
                    label: 'Ouro 10K',
                    type: "number",
                    required: true,
                },
                {
                    name: 'low_gold_crafted_index',
                    label: 'Ouro 10K Trabalhado',
                    type: "number",
                    required: true,
                },
                {
                    name: 'silver_index',
                    label: 'Prata 950',
                    type: "number",
                    required: true,
                },
                {
                    name: 'silver_crafted_index',
                    label: 'Prata 950 Trabalhada',
                    type: "number",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    useEffect(() => {
        getPriceGroupDetails(id, setFormData);
    }, [id]);

    return <DynamicFormPage details initialData={formData} title={"Grupos de Índices - Detalhes"} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;
};
